var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"frame",staticClass:"pdf-container",attrs:{"src":"/plugin/pdfjs/index.html?file=","data-src":_vm.innerSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }